module.exports = __webpack_public_path__ + "assets/5d89db8c2076d86802fcfedcf84e4e25.png";